import { mapGetters, mapActions } from 'vuex'

export const notificationActions = {
  ...mapActions('notificationStore', ['getPeriodicities', 'createReminders'])
}

export const notificationData = {
  ...mapGetters('notificationStore', [
    'periodicities',
    'periodicityDefault',
    'messageNotification',
    'messageNotificationCancelledSigned'
  ])
}
